import React from 'react';
import './styles.css';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import banner from './CFDI/banner.png';

export default function FichaTecnicaCFDI(props){


    return(<>
    <div className='contenedorGeneralFichaTecnicaCFDI'>
        <div className='contenedorFichaTecnicaCFDI'>
            <div className='contenedorImagenesFichaTecnicaCFDI'>
                <Carousel autoPlay infiniteLoop  showArrows={false} showStatus={false} showThumbs={false} dynamicHeight={true} stopOnHover={false} interval={5000}>
                <div className='contenedorImagenCarouselCFDI'><img src={banner}/>
                {/* <div className='textoOverCFDI'><h1>Gestiona, Organiza y Revisa</h1>
                <h2>cada uno de tus proyectos</h2></div> */}
                </div>
                </Carousel>
            </div>
            <div className='contenedorTextoBotonCFDI'>
                <div className='contenedorTextoFichaTecnicaCFDI'>
                    <p>
                       T&T CFDI es un software diseñado para facilitar la generación de comprobantes fiscales,
                       digitales, cómo: facturas, notas de cargo, notas de crédito, recibos de honorarios, recibos de arrendamientos, etc.
                       <br />
                       El Comprobante Fiscal Digital a través de internet (CFDI) es la modalidad que deben adoptar todos los contribuyentes
                       morales y personas físicas.
                        
                    </p>
                </div>
                <div>
                <a href={'https://procesos.tytsoftwaredemexico.com/aXR6bWlu/descargas/fichaTecnicaCFDi.pdf'} target='_blank'>
                    <button type="button" className='botonFichaTecnicaCFDI'>
                        Ver ficha técnica
                    </button>
                    </a>
                </div>
            </div>
        </div>
    </div>
    </>)
}